module.exports = __webpack_public_path__ + "img/content-filtering.40ca026e.webp";